/**
 * 根据用户权限初始化菜单
 * @param {*} router 
 * @param {*} store 
 */
import { Loading } from 'element-ui'
let loadingCount = 0;
let loading;
const startLoading = () => {
    loading = Loading.service({
        lock: true,
        text: '加载中',
        background: 'rgba(0, 0, 0, 0.6)',
        target: document.querySelector('.page-content')
    }, )
};

const endLoading = () => {
    loading.close();
};

export const openLoading = () => {
    if (loadingCount === 0) {
        startLoading();
    }
    loadingCount += 1;
};

export const closeLoading = () => {
    if (loadingCount <= 0) {
        return;
    }
    loadingCount -= 1;
    if (loadingCount === 0) {
        endLoading();
    }
};
export const initMenu = (router, store, menus) => {
    const routes = formatMenu(menus || []);
    router.addRoutes(routes);
    localStorage.setItem("routes", JSON.stringify(routes));
    store.commit('initMenu', routes);
}
const formatMenu = (menus) => {
    let routers = [];
    menus.forEach(menu => {
        let name = menu.name;
        let path = menu.path;
        let iconCls = menu.iconCls;
        let child = menu.children;
        let id = menu.id;
        if (child && child instanceof Array) {
            child = formatMenu(child);
        }
        routers.push({
            id: id,
            path: path || '',
            name: name,
            iconCls: iconCls,
            children: child
        });
    });
    return routers;
};

export const formatMoney = (s, n) => {
    if (!s) {
        return s;
    }
    var f = s < 0;
    if (f) {
        s = -s;
    }
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(),
        r = s.split(".")[1];
    var t = "";
    for (var i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return (f ? '-' : '') + t.split("").reverse().join("") + "." + r;
}

export const unformatMoney = (s) => {
    s = (s + "").replace(/[,]/g, "");
    return parseFloat(s);
};

//手机号、账号、密码身份证、税号等一些正则校验
export const pattenCheck = (str, type) => {
    if (!str) {
        return '';
    }
    switch (type) {
        case 'phone': //手机号码
            return /^1\d{10}$/.test(str);
        case 'idCard': //身份证
            return /^\d{15}|\d{18}$/.test(str);
        case 'password': //6—12位，至少包含数字、字母、特殊字符中2种
            return /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,12}$/.test(str);
        case 'newpassword': //6—12位，至少包含数字、字母、特殊字符中2种
            return /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,12}$/.test(str);
        case 'taxNo': //税号，15-20位，不能包括IOZSV五个字母
            return /^[^IOZSViozsv]{15,20}$/.test(str);
        case 'loginId': //账号，如果有的话，首位为首字母，且大于四位
            return /^[a-zA-Z].{4,}$/.test(str);
        default:
            return true;
    }

}

export const formatDateTime = (date, fmt = 'YYYY-MM-DD hh:mm:ss') => {
    date = date || new Date();
    date = ((date instanceof Date) || (typeof date) == 'number') ? new Date(date) : new Date();
    var obj = {
            'Y': date.getFullYear(),
            'M': date.getMonth() + 1,
            'D': date.getDate(),
            'w': date.getDay(),
            'h': date.getHours(),
            'm': date.getMinutes(),
            's': date.getSeconds(),
        },
        week = ['日', '一', '二', '三', '四', '五', '六'];
    for (let i in obj) {
        fmt = fmt.replace(new RegExp(i + '+', 'g'), function(e) {
            let itemStr = obj[i] + '';
            if (i === 'w') return (e.length > 2 ? '星期' : '周') + week[itemStr];
            for (let j = 0, len = itemStr.length; j < e.length - len; j++) itemStr = '0' + itemStr;
            return itemStr;
        });
    }
    return fmt;
};

export const getByteLength = (str) => {
    if (!str || str == '') {
        return 0;
    }
    return str.replace(/[^\u0000-\u00ff]/g, "  ").length;
};

export const subByteString = (str, len) => {
    var subStr = '';
    var j = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charAt(i);
        if (/^[\u0000-\u00ff]$/.test(c)) {
            j += 1;
        } else {
            j += 2;
        }
        if (j > len) {
            break;
        }
        subStr += c;
    }
    return subStr;
}

export const formatChineseMoney = (money) => {
    //汉字的数字
    var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
    //基本单位
    var cnIntRadice = new Array('', '拾', '佰', '仟');
    //对应整数部分扩展单位
    var cnIntUnits = new Array('', '万', '亿', '兆');
    //对应小数部分单位
    var cnDecUnits = new Array('角', '分', '毫', '厘');
    //整数金额时后面跟的字符
    var cnInteger = '整';
    //整型完以后的单位
    var cnIntLast = '元';
    //最大处理的数字
    var maxNum = 999999999999999.9999;
    //金额整数部分
    var integerNum;
    //金额小数部分
    var decimalNum;
    //输出的中文金额字符串
    var chineseStr = '';
    //分离金额后用的数组，预定义
    var parts;
    if (money == '') { return ''; }
    money = parseFloat(money);
    if (money >= maxNum) {
        //超出最大处理数字
        return '';
    }
    if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
    }
    //转换为字符串
    money = money.toString();
    if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
    } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
            var n = integerNum.substr(i, 1);
            var p = IntLen - i - 1;
            var q = p / 4;
            var m = p % 4;
            if (n == '0') {
                zeroCount++;
            } else {
                if (zeroCount > 0) {
                    chineseStr += cnNums[0];
                }
                //归零
                zeroCount = 0;
                chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
            }
            if (m == 0 && zeroCount < 4) {
                chineseStr += cnIntUnits[q];
            }
        }
        chineseStr += cnIntLast;
    }
    //小数部分
    if (decimalNum != '') {
        var decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
            var n = decimalNum.substr(i, 1);
            if (n != '0') {
                chineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
        }
    }
    if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == '') {
        chineseStr += cnInteger;
    }
    return chineseStr;
}


export const getCurrentMonthFirst = () => {
    var date = new Date();
    date.setDate(1);
    var month = parseInt(date.getMonth() + 1);
    var day = date.getDate();
    if (month < 10) {
        month = '0' + month
    }
    if (day < 10) {
        day = '0' + day
    }
    return date.getFullYear() + '-' + month + '-' + day + ' 00:00:00';
}
export const getCurrentMonthLast = () => {
    var date = new Date();
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    var lastTime = new Date(nextMonthFirstDay - oneDay);
    var month = parseInt(lastTime.getMonth() + 1);
    var day = lastTime.getDate();
    if (month < 10) {
        month = '0' + month
    }
    if (day < 10) {
        day = '0' + day
    }
    return date.getFullYear() + '-' + month + '-' + day + ' 23:59:59';
}

/**
 * 格式化数字
 * @param {*} f - 浮点数 
 * @param {*} n - 保留小数位数
 */
export const formatNumber = (f, n) => {
    if (!f) {
        return f;
    }
    if (f instanceof String) {
        var i = f.lastIndexOf('.');
        if (i < 0 || i >= (f.length - n - 1)) {
            return f;
        }
        f = parseFloat(f);
    }
    f = f.toFixed(n);
    return f;
}

export const removeEmptyField = (obj) => {
    var newObj = {}
    if (typeof obj === 'string') {
        obj = JSON.parse(obj)
    }
    if (obj instanceof Array) {
        newObj = []
    }
    if (obj instanceof Object) {
        for (var attr in obj) {
            // 属性值不为'',null,undefined才加入新对象里面(去掉'',null,undefined)
            if (obj.hasOwnProperty(attr) && obj[attr] !== '' && obj[attr] !== null && obj[attr] !== undefined) {
                if (obj[attr] instanceof Object) {
                    // 空数组或空对象不加入新对象(去掉[],{})
                    if (JSON.stringify(obj[attr]) === '{}' || JSON.stringify(obj[attr]) === '[]') {
                        continue
                    }
                    // 属性值为对象,则递归执行去除方法
                    newObj[attr] = removeEmptyField(obj[attr])
                } else if (
                    typeof obj[attr] === 'string' &&
                    ((obj[attr].indexOf('{') > -1 && obj[attr].indexOf('}') > -1) ||
                        (obj[attr].indexOf('[') > -1 && obj[attr].indexOf(']') > -1))
                ) {
                    // 属性值为JSON时
                    try {
                        var attrObj = JSON.parse(obj[attr])
                        if (attrObj instanceof Object) {
                            newObj[attr] = removeEmptyField(attrObj)
                        }
                    } catch (e) {
                        newObj[attr] = obj[attr]
                    }
                } else {
                    newObj[attr] = obj[attr]
                }
            }
        }
    }
    return newObj
}
export const toPercent = (point) => {
    let str = point
        // var str = Number(point * 100).toFixed(1);
    str = Math.round(str * 10000);
    str = str / 100;
    str += "%";
    return str;
}

export const checkTime = (dateAr) => {
    function Time() {
        for (let k in dateAr) {
            if (!judege(k)) {
                return false
            }
        }
        return true
    }

    function judege(idx) {
        for (let k in dateAr) {
            // console.log(dateAr[k].accepTimeStart)
            if (idx !== k) {
                if (dateAr[k].accepTimeStart < dateAr[idx].accepTimeStart && dateAr[k].accepTimeEnd > dateAr[idx].accepTimeStart) {
                    return false
                }
                if (dateAr[k].accepTimeStart < dateAr[idx].accepTimeEnd && dateAr[k].accepTimeEnd > dateAr[idx].accepTimeEnd) {
                    return false
                }
            }
        }
        return true
    }
    return Time()
}

export const findToChooseTree = tree => {
    //不处理镇数据
    if (!tree || tree.length < 1) return [];
    var proArr = [], cityArr = [], areaArr = [], townArr = [];
    tree.forEach(item => {
        if (item.deep == 0) {
            proArr.push({
                label: item.extName,
                value: item.extId,
                keyValue: item.extName + '-' + item.extId,
                id: item.id,
                pid: item.pid,
            });
        }
        if (item.deep == 1) {
            cityArr.push({
                label: item.extName,
                value: item.extId,
                keyValue: item.extName + '-' + item.extId,
                id: item.id,
                pid: item.pid,
            })
        }
        if (item.deep == 2) {
            areaArr.push({
                label: item.extName,
                value: item.extId,
                keyValue: item.extName + '-' + item.extId,
                id: item.id,
                pid: item.pid,
            })
        }

        if (item.deep == 3) {
            townArr.push({
                label: item.extName,
                value: item.extId,
                keyValue: item.extName + '-' + item.extId,
                id: item.id,
                pid: item.pid,
            })
        }

    })

    areaArr.forEach(atem => {
        var id = atem.id;
        var children = [];
        townArr.forEach(i => {
            if (id == i.pid) {
                children.push(i)
            }
        })
        atem.children = children
    })

    cityArr.forEach(atem => {
        var id = atem.id;
        var children = [];
        areaArr.forEach(i => {
            if (id == i.pid) {
                children.push(i)
            }
        })
        atem.children = children
    })
    
    proArr.forEach(atem => {
        var id = atem.id;
        var children = [];
        cityArr.forEach(i => {
            if (id == i.pid) {
                children.push(i)
            }
        })
        atem.children = children
    })
    console.log("开始请我去", proArr);
    return proArr;

}
//递归处理数据
export const findToTree = tree => {
    if (!tree || tree.length < 1) return [];
    var proArr = [], cityArr = [], areaArr = [], townArr = [];
    tree.forEach(item => {
        if (item.deep == 0) {
            proArr.push({
                label: item.extName,
                value: item.extId,
                keyValue: item.extName + '-' + item.extId,
                id: item.id,
                pid: item.pid,
                deep: 0
            });
        }
        if (item.deep == 1) {
            cityArr.push({
                label: item.extName,
                value: item.extId,
                keyValue: item.extName + '-' + item.extId,
                id: item.id,
                pid: item.pid,
                deep: 1
            })
        }
        if (item.deep == 2) {
            areaArr.push({
                label: item.extName,
                value: item.extId,
                keyValue: item.extName + '-' + item.extId,
                id: item.id,
                pid: item.pid,
                deep: 2
            })
        }
    })

    cityArr.forEach(atem => {
        var id = atem.id;
        var children = [];
        areaArr.forEach(i => {
            if (id == i.pid) {
                children.push(i)
            }
        })
        atem.children = children
    })
    
    proArr.forEach(atem => {
        var id = atem.id;
        var children = [];
        cityArr.forEach(i => {
            if (id == i.pid) {
                children.push(i)
            }
        })
        atem.children = children
    })
    console.log("开始请我去", proArr);
    return proArr;
}

//日期比较大小
export const diffTime = (date, otherDate) =>{
    var year = date.substring(0,4);
    var month = date.substring(5,7);
    var day = date.substring(8,10);

    var opra_year = otherDate.substring(0,4);
    var opra_month = otherDate.substring(5,7);
    var opra_day = otherDate.substring(8,10);
    
    var date_time = new Date(year,month,day);
    var opra_time = new Date(opra_year,opra_month,opra_day);

   if(opra_time.getTime() - date_time.getTime() >= 0){
     
        return true
    
    }else{
        return false
    }
}
//日期比较大小
export const diffTime_start = (date, otherDate) =>{
    var year = date.substring(0,4);
    var month = date.substring(5,7);
    var day = date.substring(8,10);

    var opra_year = otherDate.substring(0,4);
    var opra_month = otherDate.substring(5,7);
    var opra_day = otherDate.substring(8,10);
    
    var date_time = new Date(year,month,day);
    var opra_time = new Date(opra_year,opra_month,opra_day);

   if(opra_time.getTime() - date_time.getTime() > 0){
     
        return true
    
    }else{
        return false
    }
}
//日期比较大小
export const diffTime1 = (date, otherDate) =>{
    var m1 = date.replace(/-/g, "/");
    var m2 = otherDate.replace(/-/g, "/");

    var date_time = Date.parse(m1);
    var opra_time = Date.parse(m2);

   if(opra_time - date_time >= 0){
     
        return true
    
    }else{
        return false
    }
}
//日期比较大小
export const diffTime2 = (date, otherDate) =>{
    var m1 = date.replace(/-/g, "/");
    var m2 = otherDate.replace(/-/g, "/");

    var date_time = Date.parse(m1);
    var opra_time = Date.parse(m2);

   if(opra_time - date_time > 0){
     
        return true
    
    }else{
        return false
    }
}

//计算两个日期之间相差的年数
function getYearDiff(startDate, endDate) {
    return Math.abs(new Date(startDate).getTime() - new Date(endDate).getTime()) / (1000 * 3600 * 24 * 365)
}

/**
 * 格式化年差异数值
 */
export const formatYearDiff = (startDate, endDate) => {
    var yearDiff = getYearDiff(startDate, endDate);
    return Number(yearDiff.toString().match(/^\d+(?:\.\d{0,6})?/))
}

//递归冻结对象
export const deepFreeze = (obj) => {
      Object.keys(obj).forEach(name => {
        let prop = obj[name];
        if (typeof prop == "object" && prop !== null) {
          deepFreeze(prop);
        }
      });
      return Object.freeze(obj);
};

    
//防抖节流
export const throttle = (func, limit) => {
    let lastRan;
    return function (...args) {
    const now = Date.now();
    if (!lastRan || now - lastRan >= limit) {
        func.apply(this, args);
        lastRan = now;
    }
    };
}



// WEBPACK FOOTER //
// ./src/utils/utils.js